/* LP do Hit 10x1 — comportamentos das dobras.
   Três coisas: o seletor de ofertas da hero, o comparador antes/depois e o
   quiz de diagnóstico. Cada um só liga se a dobra correspondente existir. */
(function () {
  'use strict';

  /* Cada dobra da LP é uma section, e cada section carrega este arquivo — assim
     nenhuma depende da outra para funcionar. O navegador baixa uma vez só, mas
     executaria uma vez por tag: a trava abaixo garante um único registro de
     ouvintes. */
  if (window.__lofLpHit) return;
  window.__lofLpHit = true;

  var money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  function fmt(c) { return money.format((c || 0) / 100); }

  /* ─────────── Ofertas da hero ───────────
     Cada oferta é um bloco do editor, com variante e quantidade próprias. O
     clique troca o preço mostrado e o que o botão adiciona. */
  (function ofertas() {
    var caixa = document.querySelector('[data-lph-buy]');
    if (!caixa) return;

    var opcoes = Array.prototype.slice.call(caixa.querySelectorAll('[data-oferta]'));
    var botao = caixa.querySelector('[data-lph-add]');
    var elAgora = caixa.querySelector('[data-lph-agora]');
    var elAntes = caixa.querySelector('[data-lph-antes]');
    var elOff = caixa.querySelector('[data-lph-off]');
    var elParc = caixa.querySelector('[data-lph-parc]');
    if (!opcoes.length || !botao) return;

    var maxParc = parseInt(caixa.getAttribute('data-parcelas'), 10) || 0;
    var minParc = parseInt(caixa.getAttribute('data-parcela-min'), 10) || 0;

    function parcelas(total) {
      var n = maxParc;
      if (minParc > 0 && n > 1) {
        var cabe = Math.floor(total / minParc);
        if (cabe < n) n = cabe;
      }
      return n > 1 && total > 0
        ? 'ou até ' + n + 'x de ' + fmt(Math.round(total / n)) + ' sem juros'
        : '';
    }

    /* Barra fixa: mesma oferta, mesmo preço, mesmo botão. */
    var barra = document.querySelector('[data-lph-buybar]');
    var barraPreco = barra && barra.querySelector('[data-buybar-preco]');
    var barraBtn = barra && barra.querySelector('[data-buybar-add]');

    function selecionar(alvo) {
      opcoes.forEach(function (o) {
        var on = o === alvo;
        o.setAttribute('data-on', on ? '1' : '0');
        var radio = o.querySelector('input');
        if (radio) radio.checked = on;
      });

      var preco = parseInt(alvo.getAttribute('data-preco'), 10) || 0;
      var comparar = parseInt(alvo.getAttribute('data-comparar'), 10) || 0;

      if (barraPreco) {
        var rot = alvo.querySelector('.lph-oferta__nome');
        barraPreco.innerHTML = '<b>' + fmt(preco) + '</b>' +
          (rot ? ' · ' + rot.childNodes[0].textContent.trim() : '');
      }

      if (elAgora) elAgora.textContent = fmt(preco);
      if (elAntes) {
        elAntes.textContent = comparar > preco ? fmt(comparar) : '';
        elAntes.hidden = !(comparar > preco);
      }
      if (elOff) {
        var pct = comparar > preco ? Math.round((comparar - preco) * 100 / comparar) : 0;
        elOff.textContent = pct ? '-' + pct + '%' : '';
        elOff.hidden = !pct;
      }
      if (elParc) elParc.textContent = parcelas(preco);
    }

    opcoes.forEach(function (o) {
      o.addEventListener('click', function () { selecionar(o); });
      o.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); selecionar(o); }
      });
    });

    selecionar(opcoes.filter(function (o) { return o.getAttribute('data-on') === '1'; })[0] || opcoes[0]);

    function comprar(botaoClicado) {
      var alvo = opcoes.filter(function (o) { return o.getAttribute('data-on') === '1'; })[0];
      if (!alvo) return;

      /* Cada oferta pode ser mais de um item (ex.: kit montado na mão). */
      var itens = [];
      /* A linha do brinde entra marcada com _brinde, como as que o
         cart-gift.js cria: é assim que o carrinho a reconhece para o selo e,
         principalmente, para a rede de segurança que remove o item se o
         desconto do Shopify não zerar a linha. Sem a marca, um desconto
         expirado cobraria o brinde sem ninguém perceber. */
      var brinde = alvo.getAttribute('data-brinde');
      alvo.getAttribute('data-itens').split(',').forEach(function (par) {
        var p = par.split(':');
        if (!p[0]) return;
        var item = { id: Number(p[0]), quantity: Number(p[1]) || 1 };
        if (brinde && p[0] === brinde) item.properties = { _brinde: 'oferta' };
        itens.push(item);
      });
      if (!itens.length) return;

      botaoClicado.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: itens })
      })
        .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
        .then(function () {
          var t = document.querySelector('[data-cart-toggle]');
          if (t) t.click();
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () { botaoClicado.disabled = false; });
    }

    botao.addEventListener('click', function () { comprar(botao); });
    if (barraBtn) barraBtn.addEventListener('click', function () { comprar(barraBtn); });

    /* Botão de compra fora da hero (o remate do comparativo, por exemplo) entra
       pela mesma porta: quem manda é sempre a oferta marcada lá em cima. Por
       delegação, para valer também para dobra ligada depois no editor. */
    document.addEventListener('click', function (e) {
      var extra = e.target.closest('[data-lph-comprar]');
      if (extra && !extra.disabled) comprar(extra);
    });

    /* A barra entra assim que a pessoa começa a rolar e sai só quando as
       ofertas estão de fato na tela — ali o botão de verdade está à mão e a
       barra só cobriria conteúdo. Antes ela esperava a caixa inteira da hero
       passar, o que no desktop levava meia página.

       Medimos a posição no scroll em vez de usar IntersectionObserver: é o
       botão de compra da página inteira, não vale depender de um observer que
       pode não disparar em contexto embutido. */
    if (barra) {
      var ROLOU = 100;
      var ofertas = document.querySelector('.lph-ofertas') || caixa;

      var medir = function () {
        var alt = window.innerHeight;
        var r = ofertas.getBoundingClientRect();
        /* "Nas ofertas" é o bloco ocupando a tela, não uma borda espiando:
           por isso as margens dos dois lados. */
        var naOferta = r.top < alt - 80 && r.bottom > 100;
        var mostrar = window.scrollY > ROLOU && !naOferta;
        barra.classList.toggle('is-on', mostrar);
        document.body.classList.toggle('lph-buybar-on', mostrar);
      };
      window.addEventListener('scroll', medir, { passive: true });
      window.addEventListener('resize', medir, { passive: true });
      medir();
    }
  })();

  /* ─────────── Leve junto ───────────
     Adiciona a variante e abre o carrinho, sem tirar a pessoa da página. */
  (function upsell() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lph-add-produto]');
      if (!btn || btn.disabled) return;

      var id = Number(btn.getAttribute('data-variante'));
      if (!id) return;

      var rotulo = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adicionando…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
        .then(function () {
          var t = document.querySelector('[data-cart-toggle]');
          if (t) t.click();
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () { btn.disabled = false; btn.textContent = rotulo; });
    });
  })();

  /* ─────────── Stories de resultado ───────────
     Bolinhas que abrem vídeo em tela cheia, com barra de progresso e navegação
     por toque nas laterais. */
  (function stories() {
    var raiz = document.querySelector('.nvsv');
    if (!raiz) return;

    var bolhas = Array.prototype.slice.call(raiz.querySelectorAll('.nvsv__bubble'));
    var modal = raiz.querySelector('.nvsvm');
    if (!bolhas.length || !modal) return;

    var video = modal.querySelector('.nvsvm__video');
    var legenda = modal.querySelector('.nvsvm__caption');
    var progresso = modal.querySelector('.nvsvm__progress span');
    var atual = -1;

    function fonte(i) {
      var v = bolhas[i].querySelector('.nvsv__hidden source');
      return v ? v.getAttribute('src') : '';
    }

    function tocar(i) {
      if (i < 0 || i >= bolhas.length) { fechar(); return; }
      atual = i;
      var src = fonte(i);
      if (!src) { tocar(i + 1); return; }

      bolhas[i].classList.add('is-visto');
      legenda.textContent = bolhas[i].getAttribute('data-caption') ||
                            (bolhas[i].querySelector('.nvsv__name') || {}).textContent || '';
      progresso.style.width = '0%';
      video.src = src;
      video.currentTime = 0;
      video.play().catch(function () {});
    }

    function abrir(i) {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      tocar(i);
    }

    function fechar() {
      modal.hidden = true;
      document.body.style.overflow = '';
      video.pause();
      video.removeAttribute('src');
      video.load();
      atual = -1;
    }

    bolhas.forEach(function (b, i) {
      b.addEventListener('click', function () { abrir(i); });
    });

    video.addEventListener('timeupdate', function () {
      if (!video.duration) return;
      progresso.style.width = (video.currentTime / video.duration * 100) + '%';
    });
    video.addEventListener('ended', function () { tocar(atual + 1); });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) { fechar(); return; }
      if (e.target.closest('[data-next]')) { tocar(atual + 1); return; }
      if (e.target.closest('[data-prev]')) { tocar(atual - 1); }
    });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') fechar();
      if (e.key === 'ArrowRight') tocar(atual + 1);
      if (e.key === 'ArrowLeft') tocar(atual - 1);
    });
  })();

  /* ─────────── Antes e depois ─────────── */
  (function antesDepois() {
    document.querySelectorAll('[data-lph-ba]').forEach(function (bloco) {
      var range = bloco.querySelector('input[type="range"]');
      if (!range) return;
      function pintar() { bloco.style.setProperty('--pos', range.value + '%'); }
      range.addEventListener('input', pintar);
      pintar();
    });
  })();

  /* ─────────── Quiz de diagnóstico ───────────
     Para editar: mexa em PERGUNTAS. Cada opção distribui pontos entre as seis
     linhas; no fim vence a de maior pontuação (empate = primeira da ordem). */
  (function quiz() {
    var raiz = document.querySelector('[data-lph-quiz]');
    if (!raiz) return;

    var LINHAS = {
      repair:    { nome: 'Repair',    frase: 'reconstrução para fio danificado' },
      nutritive: { nome: 'Nutritive', frase: 'nutrição para fio ressecado' },
      hydrate:   { nome: 'Hydrate',   frase: 'hidratação profunda no dia a dia' },
      silver:    { nome: 'Silver',    frase: 'matização para loiro e grisalho' },
      purifying: { nome: 'Purifying', frase: 'limpeza vegana e leve' },
      wavy:      { nome: 'Wavy',      frase: 'definição para ondas e cachos' }
    };

    var PERGUNTAS = [
      { p: 'Como é o seu cabelo?', o: [
        { t: 'Liso', v: { hydrate: 2, nutritive: 1 } },
        { t: 'Ondulado', v: { wavy: 2, hydrate: 1 } },
        { t: 'Cacheado', v: { wavy: 3, nutritive: 1 } },
        { t: 'Crespo', v: { wavy: 2, nutritive: 2 } }
      ] },
      { p: 'Ele passou por alguma química?', o: [
        { t: 'Nenhuma', v: { hydrate: 2, purifying: 1 } },
        { t: 'Coloração', v: { nutritive: 2, repair: 1 } },
        { t: 'Descoloração ou mechas', v: { repair: 3, silver: 2 } },
        { t: 'Progressiva ou relaxamento', v: { repair: 3, nutritive: 1 } }
      ] },
      { p: 'O que mais te incomoda hoje?', o: [
        { t: 'Quebra e pontas duplas', v: { repair: 3 } },
        { t: 'Ressecamento', v: { nutritive: 3, hydrate: 1 } },
        { t: 'Frizz e volume', v: { hydrate: 2, wavy: 1 } },
        { t: 'Tom amarelado', v: { silver: 3 } },
        { t: 'Raiz oleosa', v: { purifying: 3 } }
      ] },
      { p: 'Com que frequência você usa secador ou prancha?', o: [
        { t: 'Todo dia', v: { repair: 2, nutritive: 1 } },
        { t: 'Algumas vezes por semana', v: { hydrate: 1, nutritive: 1 } },
        { t: 'Quase nunca', v: { purifying: 1, wavy: 1 } }
      ] },
      { p: 'Como o seu couro cabeludo se comporta?', o: [
        { t: 'Oleoso', v: { purifying: 3 } },
        { t: 'Normal', v: { hydrate: 1 } },
        { t: 'Seco', v: { nutritive: 2 } }
      ] },
      { p: 'O que você quer primeiro?', o: [
        { t: 'Recuperar o fio', v: { repair: 3 } },
        { t: 'Mais maciez e brilho', v: { nutritive: 2, hydrate: 2 } },
        { t: 'Segurar o loiro', v: { silver: 3 } },
        { t: 'Cachos definidos', v: { wavy: 3 } }
      ] }
    ];

    var passo = 0;
    var placar = {};
    var historico = [];

    var elProg = raiz.querySelector('[data-quiz-prog]');
    var elCorpo = raiz.querySelector('[data-quiz-corpo]');
    var urlBase = raiz.getAttribute('data-url-colecoes') || '/collections';
    var hitUrl = raiz.getAttribute('data-url-hit') || '';
    var hitTitulo = raiz.getAttribute('data-hit-titulo') || 'Hit 10x1';

    function esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
                      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function progresso() {
      if (elProg) elProg.style.width = (passo / PERGUNTAS.length * 100) + '%';
    }

    function desenharPergunta() {
      var q = PERGUNTAS[passo];
      var html = '<p class="lph-quiz__passo">Pergunta ' + (passo + 1) + ' de ' + PERGUNTAS.length + '</p>' +
                 '<p class="lph-quiz__p">' + esc(q.p) + '</p>' +
                 '<div class="lph-quiz__ops">';
      q.o.forEach(function (op, i) {
        html += '<button type="button" class="lph-quiz__op" data-op="' + i + '">' + esc(op.t) + '</button>';
      });
      html += '</div>';
      if (passo > 0) {
        html += '<div class="lph-quiz__nav"><button type="button" class="lph-quiz__voltar" data-voltar>← Voltar</button></div>';
      }
      elCorpo.innerHTML = html;
      progresso();
    }

    function vencedora() {
      var chaves = Object.keys(LINHAS);
      var melhor = chaves[0];
      chaves.forEach(function (k) {
        if ((placar[k] || 0) > (placar[melhor] || 0)) melhor = k;
      });
      return melhor;
    }

    function desenharResultado() {
      var k = vencedora();
      var linha = LINHAS[k];
      if (elProg) elProg.style.width = '100%';

      var html = '<div class="lph-quiz__res">' +
        '<div>' +
          '<p class="lph-quiz__passo">Seu protocolo</p>' +
          '<p class="lph-quiz__linha">Linha ' + esc(linha.nome) + '</p>' +
          '<p class="lph-lead">Pelo que você respondeu, a sua rotina começa pela ' + esc(linha.frase) + '. ' +
          'O ' + esc(hitTitulo) + ' entra depois, em toda finalização, para o calor não desfazer o tratamento.</p>' +
        '</div>' +
        '<div class="lph-quiz__acoes">' +
          '<a class="lph-btn" href="' + esc(urlBase) + '/' + esc(k) + '">Ver a linha ' + esc(linha.nome) + '</a>' +
          (hitUrl ? '<a class="lph-btn lph-btn--ghost" href="' + esc(hitUrl) + '">Levar o ' + esc(hitTitulo) + '</a>' : '') +
        '</div>' +
        '<div class="lph-quiz__nav"><button type="button" class="lph-quiz__voltar" data-refazer>Refazer o diagnóstico</button></div>' +
      '</div>';
      elCorpo.innerHTML = html;
    }

    raiz.addEventListener('click', function (e) {
      var op = e.target.closest('[data-op]');
      if (op) {
        var escolha = PERGUNTAS[passo].o[Number(op.getAttribute('data-op'))];
        historico.push(escolha.v);
        Object.keys(escolha.v).forEach(function (k) {
          placar[k] = (placar[k] || 0) + escolha.v[k];
        });
        passo++;
        if (passo >= PERGUNTAS.length) desenharResultado();
        else desenharPergunta();
        return;
      }

      if (e.target.closest('[data-voltar]')) {
        passo = Math.max(0, passo - 1);
        var ultimo = historico.pop();
        if (ultimo) {
          Object.keys(ultimo).forEach(function (k) { placar[k] -= ultimo[k]; });
        }
        desenharPergunta();
        return;
      }

      if (e.target.closest('[data-refazer]')) {
        passo = 0; placar = {}; historico = [];
        desenharPergunta();
      }
    });

    desenharPergunta();
  })();
})();
